<template>
  <div class="bp-card-title">
    <span class="bar"></span>
    <span class="txt">{{ title }}</span>
    <span v-if="subTitle" class="sub">{{ subTitle }}</span>
  </div>
</template>

<script>
export default {
  name: 'BpCardTitle',
  props: {
    title: { type: String, default: '' },
    subTitle: { type: String, default: '' }
  }
}
</script>

<style lang="less" scoped>
@import '../styles.less';
.bp-card-title {
  display: flex;
  align-items: center;
  .bar {
    width: 6px;
    height: 18px;
    border-radius: 6px;
    background: @bp-bar-gradient;
    margin-right: 8px;
  }
  .txt {
    font-family: @font-cn;
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    color: @bp-title;
  }
  .sub {
    margin-left: 8px;
    font-size: 14px;
    color: @bp-label;
  }
}
</style>
